import Service from '@/helpers/adminService'

export default {

    index(params) {
        return Service().get('admin/careers', {params});
    },
    show(id) {
        return Service().get('admin/careers/'+id);
    },
    create(params) {
        return Service().post('admin/careers', params);
    },
    update(id, params) {
        return Service().post('admin/careers/'+id, params);
    },
    delete(id) {
        return Service().delete('admin/careers/'+id);
    },
}
